module.exports = __webpack_public_path__ + "img/bus-stop.1a8ef54e.svg";